'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _reactI18next = require('react-i18next');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _CarouselPaginator = require('../CarouselPaginator');
var _CarouselPaginator2 = _interopRequireDefault(_CarouselPaginator);
var _xTwitter = require('../../assets/icons/x-twitter.svg');
var _xTwitter2 = _interopRequireDefault(_xTwitter);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var urlRegexp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
var defaultTextColor = '#000000';
var defaultSubTextColor = '#3f3f3f';
var defaultCardBackgroundColor = '#FFFFFF';
var defaultSocialMediaColor = '#F84A4A';
var defaultBackgroundColor = '#d3d3d3';
var styles = {
  SpeakerCarousel: {
    padding: '2rem 0',
    textAlign: 'center',
    backgroundColor: function backgroundColor(_ref) {
      var blockBackgroundColor = _ref.otherProperties.blockBackgroundColor;
      return blockBackgroundColor || defaultBackgroundColor;
    },
    maxHeight: '24.4rem'
  },
  progress: {
    color: 'black'
  },
  speaker: {
    minHeight: '24.4rem',
    margin: 'auto',
    width: '15rem',
    minWidth: '192px',
    backgroundColor: function backgroundColor(_ref2) {
      var speakerCardBackgroundColor = _ref2.otherProperties.speakerCardBackgroundColor;
      return speakerCardBackgroundColor || defaultCardBackgroundColor;
    },
    color: function color(_ref3) {
      var speakerTextColor = _ref3.otherProperties.speakerTextColor;
      return speakerTextColor || defaultTextColor;
    },
    '& p': {
      margin: '16px 0'
    },
    '& span': {
      display: 'block'
    },
    '& .picture': {
      height: function height(_ref4) {
        var responsiveMode = _ref4.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? '12.5rem' : '12rem';
      },
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    '& .details': {
      padding: '16px 5px',
      whiteSpace: 'normal'
    },
    '& .name': {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      lineHeight: 'normal'
    },
    '& .position': {
      marginTop: 8,
      fontSize: '0.9rem',
      lineHeight: 'normal',
      color: function color(_ref5) {
        var speakerSubTextColor = _ref5.otherProperties.speakerSubTextColor;
        return speakerSubTextColor || defaultSubTextColor;
      }
    },
    '& .company': {
      marginTop: 2,
      fontSize: '0.9rem',
      color: function color(_ref6) {
        var speakerSubTextColor = _ref6.otherProperties.speakerSubTextColor;
        return speakerSubTextColor || defaultSubTextColor;
      },
      textTransform: 'uppercase',
      lineHeight: 'normal'
    }
  },
  socialMedia: {
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > a': {
      borderRadius: '50%',
      margin: 4,
      padding: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.25rem',
      backgroundColor: function backgroundColor(_ref7) {
        var speakerCardBackgroundColor = _ref7.otherProperties.speakerCardBackgroundColor;
        return speakerCardBackgroundColor || defaultCardBackgroundColor;
      },
      color: function color(_ref8) {
        var speakerCardSocialMediaColor = _ref8.otherProperties.speakerCardSocialMediaColor;
        return speakerCardSocialMediaColor || defaultSocialMediaColor;
      },
      textDecoration: 'none'
    },
    '& svg': {
      fill: function fill(_ref9) {
        var speakerCardSocialMediaColor = _ref9.otherProperties.speakerCardSocialMediaColor;
        return speakerCardSocialMediaColor || defaultSocialMediaColor;
      },
      width: '1.25rem',
      height: '1.25rem'
    }
  }
};
var SpeakerCarousel = function (_Component) {
  _inherits(SpeakerCarousel, _Component);
  function SpeakerCarousel() {
    var _ref10;
    var _temp, _this, _ret;
    _classCallCheck(this, SpeakerCarousel);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref10 = SpeakerCarousel.__proto__ || Object.getPrototypeOf(SpeakerCarousel)).call.apply(_ref10, [this].concat(args))), _this), _this.renderSingleItem = function (speaker) {
      var id = speaker.id,
        picture = speaker.picture,
        fullName = speaker.fullName,
        position = speaker.position,
        twitter = speaker.twitter,
        linkedin = speaker.linkedin,
        instagram = speaker.instagram,
        company = speaker.company;
      var classes = _this.props.classes;
      var picture_style = {
        backgroundImage: 'url(' + (picture.filename ? picture.large : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/avatar.png') + ')'
      };
      return _react2.default.createElement('div', {
        key: id,
        className: classes.speaker
      }, _react2.default.createElement('div', {
        className: 'picture',
        style: picture_style
      }), _react2.default.createElement('div', {
        className: 'details'
      }, _react2.default.createElement('span', {
        className: 'name'
      }, fullName), _react2.default.createElement('span', {
        className: 'company'
      }, company), _react2.default.createElement('span', {
        className: 'position'
      }, position), _react2.default.createElement('div', {
        className: classes.socialMedia
      }, twitter && _react2.default.createElement('a', {
        href: 'https://twitter.com/' + twitter,
        target: '_blank',
        className: 'mediaLink'
      }, _react2.default.createElement('svg', {
        fill: 'currentColor'
      }, _react2.default.createElement('use', {
        href: _xTwitter2.default + '#x-twitter-logo'
      }))), linkedin && _react2.default.createElement('a', {
        href: urlRegexp.test(linkedin) ? linkedin : 'https://www.linkedin.com/in/' + linkedin + '/',
        className: 'mediaLink',
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-linkedin-square'
      })), instagram && _react2.default.createElement('a', {
        href: 'https://www.instagram.com/' + instagram,
        target: '_blank',
        className: 'mediaLink'
      }, _react2.default.createElement('i', {
        className: 'fa fa-instagram'
      })))));
    }, _this.getOrderedSpeakers = function (idsByPage) {
      var orderedSpeakers = [],
        pages = Object.keys(idsByPage);
      for (var i = 0; i < pages.length; i++) {
        orderedSpeakers.push.apply(orderedSpeakers, idsByPage[pages[i]]);
      }
      return orderedSpeakers;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(SpeakerCarousel, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var otherProperties = this.props.otherProperties;
      var speakerPaginationSize = otherProperties.speakerPaginationSize;
      if (prevProps.otherProperties.speakerPaginationSize != speakerPaginationSize) {
        this.props.fetchPage();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        entities = _props.entities,
        pagination = _props.pagination,
        fetchPage = _props.fetchPage,
        responsiveMode = _props.responsiveMode,
        t = _props.t,
        otherProperties = _props.otherProperties;
      var isFetching = pagination.isFetching,
        links = pagination.links,
        idsByPage = pagination.idsByPage;
      var blockBackgroundColor = otherProperties.blockBackgroundColor;
      var speakers = !!entities && !!idsByPage && this.getOrderedSpeakers(idsByPage).map(function (orderedId) {
        return entities[orderedId];
      });
      var perGroup = void 0;
      var sharedProperties = {
        backgroundColor: blockBackgroundColor
      };
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
          perGroup = 4;
          break;
        case _ResponsiveModes.TABLET:
          perGroup = 2;
          break;
        case _ResponsiveModes.MOBILE:
        default:
          perGroup = 1;
      }
      return _react2.default.createElement('div', {
        className: classes.SpeakerCarousel,
        style: cssProperties
      }, isFetching && !(speakers && speakers.length) ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : speakers && !!speakers.length ? _react2.default.createElement(_CarouselPaginator2.default, _extends({
        items: speakers,
        renderSingleItem: this.renderSingleItem,
        fetchPage: fetchPage,
        perGroup: perGroup,
        sharedProperties: sharedProperties
      }, links)) : _react2.default.createElement('h3', null, 'No speakers :('));
    }
  }]);
  return SpeakerCarousel;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(SpeakerCarousel));